var RTCRejectAction;
(function (RTCRejectAction) {
    RTCRejectAction["DECLINE"] = "DECLINE";
    RTCRejectAction["SEND_TO_VOICEMAIL"] = "SEND_TO_VOICEMAIL";
})(RTCRejectAction || (RTCRejectAction = {}));
export default RTCRejectAction;
//# sourceMappingURL=RTCRejectAction.js.map